export const MIN_HEIGHT = 0.3; // 30vh
export const MAX_HEIGHT = 0.95; // 95vh
export const CLOSE_THRESHOLD = 0.2; // 20vh
export const KEYBOARD_STEP = 0.1; // 10vh - arrow key adjustment increment
export const SNAP_POINTS = [MIN_HEIGHT, 0.6, MAX_HEIGHT]; // Small (30%), medium (60%), large (95%)
